import React, { useCallback, useEffect, useState } from "react";
import BlockReportMaster from "./BlockReport/BlockReportMaster";
import SectionWiseBlockForEng from "./BlockReport/SectionWiseBlockForEng";
import AgreedAndGivenBlock from "./BlockReport/AgreedAndGivenBlock";

import PWIMaster from "./BlockReport/TableView/PWI/PWIMaster";
import BlockDataFilter from "./BlockReport/TableView/BlockDataFilter";
import BlockPositionMaster from "./BlockReport/TableView/Block Position/BlockPositionMasterTable";
import { getCurrentDate, getCurrentMonthFirstDate } from "../Utilitie";
import axios from "axios";
import Loading from "../Extra/Loading";
import MachineMaster from "./BlockReport/MachineMaster";
import AgreedAndGivenBlockMaster from "./BlockReport/TableView/AgreedAndGivenBlock/AgreedAndGivenBlockMaster";
import ADRMDailyBlockPositionReport from "./BlockReport/TableView/ADRMDailyBlockPosition/ADRMDailyBlockPositionReport";
import MaterialTrainReport from "./BlockReport/TableView/MaterialTrainReport/MaterialTrainReport";
import BlockPositionMasterTable from "./BlockReport/TableView/Block Position/BlockPositionMasterTable";
import ComEnggPosition from "./BlockReport/TableView/COM ENGG POSTION/ComEnggPosition";
import TWSBlockReport from "./BlockReport/TableView/TWSBlock/TWSBlockReport";
import CustomizeTableMaster from "./BlockReport/TableView/CustomizeTable/CustomizeTableMaster";
import CrewDemandPosition from "./BlockReport/TableView/Crew/CrewDemandPosition";
import PathWastage from "./BlockReport/TableView/PathWastage/PathWasatge";
import NonWorkingMaster from "./BlockReport/TableView/Non Working/NonWorkingMaster";
import SectionWiseBlockMaster from "./BlockReport/TableView/Section Wise Block/SectionWiseBloackMaster";
import CautionOrderMaster from "./BlockReport/TableView/Caution Order/CautionOrderMaster";
const opState = {
  Year: false,
  Months: false,
  Dates: false,
  "To Station": false,
  "From Station": false,
  Section: false,
  From_Station: false,
  To_Station: false,
  Department: false,
  Type: false,
  "Block Type": false,
  "Granted/Not": false,
  "Availed/Not": false,
  Burst: false,
  Corridore: false,
  Direction: false,
  Reason: false,
  Rolling_Block: false,
  "Time Slot": false,
};
const exceptPage = [
  // to remove the filters
  // "Block Reports",
  "New Section Wise Block (Eng)",
  // "Agreed And Given Block (Eng)",
  "TWS Block Report",
  // "Machine (Eng)",
  "Eng Crew Demand Position",
  // "Block Not Availed",
  "Path wastage",
  "Non Working",
  "ADRM Daily Block Position Report",
  "Caution Order",
];
const classicAndCustomReportBtns = [
  /// hide the custom and classic butn
  "COM ENGG Position",
  "Block Position",
  "Custom Report",
  "Path wastage",
  "Machine (Eng)",
  "Non Working",
  "TWS Block Report",
  // "Section Wise Block",
  "Block Reports",
  "New Section Wise Block (Eng)",
  "Block Not Availed",
  "ADRM Daily Block Position Report",
  "Material Train Report",
  "Eng Crew Demand Position",
  "Caution Order",
];
const BlockReportsBody = ({ activeReportPage }) => {
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [fetchData, setFetchData] = useState(null);
  const [customReport, setCustomReport] = useState(true);
  const [filteredData, setFilteredData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dataForTable, setDataForTable] = useState(null);
  const [error, setError] = useState(false);
  const [openStates, setOpenStates] = useState({ opState });
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [startFetch, setStartFetch] = useState(true);
  const fetchedData = useCallback(async () => {
    setLoading(true);
    setError(false);

    const source = axios.CancelToken.source();
    let url =
      activeReportPage === "Block Reports"
        ? `${urlPrefixBlock}getBlockDataDate_Only_Pre_Year?start=${startDate}&end=${endDate}`
        : `${urlPrefixBlock}getblockdatabydate?start=${startDate}&end=${endDate}`;

    try {
      const response = await axios.get(url, { cancelToken: source.token });
      const result = response.data;

      if (result.status === "ok") {
        const raw = result.daterange.data;

        const flattened = raw.flatMap((sectionItem) =>
          sectionItem.children.flatMap((dept) =>
            dept.children.flatMap((directionBlock) =>
              directionBlock.data.map((block) => ({
                ...block,
                section: sectionItem.section,
                Department: dept.Department,
                Direction: directionBlock.Direction,
              })),
            ),
          ),
        );

        setFetchData(flattened.sort((a, b) => a.Sno - b.Sno));
      }
    } catch (error) {
      if (!axios.isCancel(error)) setError(true);
    } finally {
      setLoading(false);
    }

    return () => source.cancel();
  }, [activeReportPage, startDate, endDate]);
  // Dependencies for fetchedData
  useEffect(() => {
    if (!exceptPage.includes(activeReportPage)) {
      // setCustomReport(classicAndCustomReportBtns.includes(activeReportPage));
      fetchedData();
    }
  }, [activeReportPage]);
  // Include fetchedData in dependency array
  return (
    <div
      className="container-fluid px-2"
      onClick={() => {
        setOpenStates(opState);
      }}
    >
      {/* Custom / Classic Report Toggle */}
      {!classicAndCustomReportBtns.includes(activeReportPage) && (
        <div className="row mb-2">
          <div className="col-12">
            <div
              className="d-flex align-items-center justify-content-center flex-wrap gap-2 p-2 rounded shadow-sm"
              style={{
                background: "linear-gradient(135deg, #870606 0%, #732f08 100%)",
              }}
            >
              <button
                onClick={() => {
                  setCustomReport(true);
                }}
                className={`btn btn-sm ${
                  customReport ? "text-white shadow" : "btn-outline-light"
                }`}
                style={
                  customReport
                    ? {
                        background:
                          "linear-gradient(135deg, #870606 0%, #732f08 100%)",
                        border: "1px solid rgba(255,255,255,0.8)",
                      }
                    : {}
                }
              >
                Custom Report
              </button>

              <button
                onClick={() => {
                  setCustomReport(false);
                }}
                className={`btn btn-sm ${
                  !customReport ? "text-white shadow" : "btn-outline-light"
                }`}
                style={
                  !customReport
                    ? {
                        background:
                          "linear-gradient(135deg, #870606 0%, #732f08 100%)",
                        border: "1px solid rgba(255,255,255,0.8)",
                      }
                    : {}
                }
              >
                Classic Report
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Report Header / Date Filter */}
      {customReport && (
        <div>
          {exceptPage.includes(activeReportPage) ? null : (
            <div
              className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-2 text-white p-2 rounded shadow-sm"
              style={{
                background:
                  "linear-gradient(135deg, #870606 0%, #bb0a0a 50%, #732f08 100%)",
                border: "1px solid #870606",
              }}
            >
              {/* Report Title */}
              <div className="d-flex align-items-center">
                <h5 className="mb-0 fw-bold">{activeReportPage}</h5>
              </div>

              {/* Date Controls */}
              <div className="d-flex flex-column flex-sm-row align-items-sm-center gap-2">
                {/* From */}
                <div className="d-flex align-items-center gap-1">
                  <label className="fw-semibold mb-0">From</label>

                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="form-control form-control-sm"
                  />
                </div>

                {/* To */}
                <div className="d-flex align-items-center gap-1">
                  <label className="fw-semibold mb-0">To</label>

                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="form-control form-control-sm"
                  />

                  <button
                    type="button"
                    className="btn btn-sm text-white fw-semibold"
                    style={{
                      background:
                        "linear-gradient(135deg, #870606 0%, #732f08 100%)",
                      border: "1px solid rgba(255,255,255,0.8)",
                    }}
                    onClick={() => {
                      fetchedData();
                      setStartFetch(!startFetch);
                    }}
                  >
                    Fetch
                  </button>
                </div>
              </div>
            </div>
          )}

          {loading && <Loading />}
        </div>
      )}

      {/* Filters */}
      {fetchData && customReport && !exceptPage.includes(activeReportPage) && (
        <div className="sticky-controller">
          <BlockDataFilter
            activeReportPage={activeReportPage}
            data={fetchData}
            setFilteredData={setFilteredData}
            openStates={openStates}
            setOpenStates={setOpenStates}
            setDataForTable={setDataForTable}
          />
        </div>
      )}

      {/* Reports */}
      {activeReportPage === "Block Reports" && (
        <BlockReportMaster
          data={filteredData}
          dataForTable={dataForTable}
          dates={{ startDate, endDate }}
        />
      )}

      {activeReportPage === "Agreed And Given Block (Eng)" && (
        <AgreedAndGivenBlockMaster
          customReport={customReport}
          data={filteredData}
        />
      )}

      {activeReportPage === "New Section Wise Block (Eng)" && (
        <SectionWiseBlockForEng />
      )}

      {activeReportPage === "Machine (Eng)" && (
        <MachineMaster
          customReport={customReport}
          data={filteredData}
          date={{ startDate, endDate }}
          startFetch={startFetch}
        />
      )}

      {activeReportPage === "Block Not Availed" && (
        <PWIMaster data={filteredData} />
      )}

      {activeReportPage === "Block Position" && (
        <BlockPositionMasterTable
          data={filteredData}
          customReport={true}
          dataForTable={dataForTable}
        />
      )}

      {activeReportPage === "ADRM Daily Block Position Report" && (
        <ADRMDailyBlockPositionReport />
      )}

      {activeReportPage === "Material Train Report" && (
        <MaterialTrainReport data={filteredData} />
      )}

      {activeReportPage === "COM ENGG Position" && (
        <ComEnggPosition data={filteredData} />
      )}

      {activeReportPage === "TWS Block Report" && (
        <TWSBlockReport data={filteredData} />
      )}

      {activeReportPage === "Custom Report" && (
        <CustomizeTableMaster data={filteredData} />
      )}

      {activeReportPage === "Eng Crew Demand Position" && (
        <CrewDemandPosition />
      )}

      {activeReportPage === "Path wastage" && <PathWastage />}

      {activeReportPage === "Non Working" && <NonWorkingMaster />}

      {activeReportPage === "Section Wise Block" && (
        <SectionWiseBlockMaster data={filteredData} />
      )}

      {activeReportPage === "Caution Order" && <CautionOrderMaster />}
    </div>
  );
};
export default BlockReportsBody;
